import {Component, OnInit, HostListener} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {StockistService} from '../../../shared/services/stockist.service';
import {UserService} from '../../../shared/services/user.service';
import {ActivatedRoute, Router} from '@angular/router';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {StateService} from '../../../shared/services/state.service';
import {AlertService} from '../../../shared/services/alert.service';

@Component({
    selector: 'app-members',
    templateUrl: './members.component.html',
    styleUrls: ['./members.component.scss']
})
export class MembersComponent implements OnInit {
    showSearch = false;
    searchForm: FormGroup;
    states: any = [];
    members: any = [];
    submitting: any = false;
    submitted: any = false;
    userData: any;
    selectedMemberParent: any;
    selectedAlignment: any;
    addMemberForm: FormGroup;
    inputTypePassword: any = 'password';
    inputTypeConfirmPassword: any = 'password';

    constructor(private fb: FormBuilder,
                private stockistService: StockistService,
                private activatedRoute: ActivatedRoute,
                private router: Router,
                private userService: UserService,
                private stateService: StateService,
                public alertService: AlertService,
                public modalService: NgbModal) {
    }

    ngOnInit(): void {
        this.refresh();
    }

    @HostListener('window:popstate', ['$event'])
    onPopState(event) {
        location.reload()
    }

    refresh() {
        this.addMemberForm = this.fb.group({
            'name': ['', Validators.required],
            'email': ['', Validators.compose([Validators.pattern('^(([^<>()[\\]\\\\.,;:\\s@\\"]+(\\.[^<>()[\\]\\\\.,;:\\s@\\"]+)*)|(\\".+\\"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$')])],
            'username': ['', [Validators.required, Validators.pattern('^(?!.*09$)(?=.*[a-zA-Z])[a-zA-Z0-9]+$')]],
            'password': ['', Validators.required],
            'confirm_password': ['', Validators.required],
            'contact': ['', Validators.compose([Validators.required, Validators.pattern('^[5-9]{1}[0-9]{9}$')])],
            'address': ['', Validators.required],
            'city': ['', Validators.required],
            'state_id': ['', Validators.required],
            'pin_code': ['', Validators.required]
        });
        this.searchForm =  this.fb.group({
            'member_id' : [''],
            'username' : [''],
        });
        this.getStates();
    }

    getStates() {
        this.stateService.get().subscribe(data => {
            if (data && data['data'].length > 0) {
                this.states = data['data'];
                this.getUserDetail();
            }
        });
    }

    getUserDetail() {
        this.userService.selfDetail().subscribe(data => {
            if (data) {
                this.userData = data;
                this.get();
            }
        });
    }

    get(params: any = {}) {
        this.submitting = true;
        this.members = [];
        if (this.activatedRoute.snapshot.params['searchData']) {
            this.userService.getMatchingTree(this.activatedRoute.snapshot.params['searchData'], params).subscribe(data => {
                if (data) {
                    this.members = data;
                } else {
                    this.members = [];
                }
                this.submitting = false;
            }, error => {
                this.submitting = false;
            });
        }  else {
            this.userService.getMatchingTree(this.userData['member_id'], params).subscribe(data => {
                if (data) {
                    this.members = data;
                } else {
                    this.members = [];
                }
                this.submitting = false;
            }, error => {
                this.submitting = false;
            });
        }
    }

    navigateUser(user) {
        this.router.navigate(['members/' + user['member_id']]).then(() => {
            window.location.reload();
        });
    }

    search() {
        const params = {
            'member_id': (this.searchForm.value && this.searchForm.value.member_id) ? this.searchForm.value.member_id : '',
            'username': (this.searchForm.value && this.searchForm.value.username) ? this.searchForm.value.username : ''
        };
        if (params && params['member_id']) {
            this.router.navigate(['members/' + params['member_id']]).then(() => {
                window.location.reload();
            });
        }
        if (params && params['username']) {
            this.router.navigate(['members/' + params['username']]).then(() => {
                window.location.reload();
            });
        }
    }

    goTo(url) {
        this.router.navigateByUrl(url);
    }

    openAddMemberModal(content, parent, alignment) {
        if (parent && parent.id) {
            this.addMemberForm.patchValue({
                'name': '',
                'email': '',
                'username': '',
                'password': '',
                'confirm_password': '',
                'contact': '',
                'address': '',
                'city': '',
                'state_id': '',
                'pin_code': ''
            });
            this.selectedMemberParent = parent;
            this.selectedAlignment = alignment;
            this.modalService.open(content, {'size': 'lg'});
        } else {
            this.alertService.showErrors('You can\'t add member in this position');
        }
    }

    addMember() {
        this.submitted = true;
        if (!this.addMemberForm.valid) {
            return;
        }
        if (this.addMemberForm.getRawValue().password !== this.addMemberForm.getRawValue().confirm_password) {
            this.alertService.showErrors('Password & Confirm Password didn\'t match');
            return;
        }
        if (this.submitted) {
            const params = {
                'name': (this.addMemberForm && this.addMemberForm.getRawValue() && this.addMemberForm.getRawValue().name) ? this.addMemberForm.getRawValue().name : '',
                'username': (this.addMemberForm && this.addMemberForm.getRawValue() && this.addMemberForm.getRawValue().username) ? this.addMemberForm.getRawValue().username : '',
                'email': (this.addMemberForm && this.addMemberForm.getRawValue() && this.addMemberForm.getRawValue().email) ? this.addMemberForm.getRawValue().email : 'NULL',
                'contact': (this.addMemberForm && this.addMemberForm.getRawValue() && this.addMemberForm.getRawValue().contact) ? this.addMemberForm.getRawValue().contact : '',
                'password': (this.addMemberForm && this.addMemberForm.getRawValue() && this.addMemberForm.getRawValue().password) ? this.addMemberForm.getRawValue().password : '',
                'address': (this.addMemberForm && this.addMemberForm.getRawValue() && this.addMemberForm.getRawValue().address) ? this.addMemberForm.getRawValue().address : '',
                'state_id': (this.addMemberForm && this.addMemberForm.getRawValue() && this.addMemberForm.getRawValue().state_id) ? this.addMemberForm.getRawValue().state_id : '',
                'city': (this.addMemberForm && this.addMemberForm.getRawValue() && this.addMemberForm.getRawValue().city) ? this.addMemberForm.getRawValue().city : '',
                'pin_code': (this.addMemberForm && this.addMemberForm.getRawValue() && this.addMemberForm.getRawValue().pin_code) ? this.addMemberForm.getRawValue().pin_code : '',
                'parent_id': this.selectedMemberParent.id,
                'level': (this.selectedMemberParent && this.selectedMemberParent.level) ? parseInt(this.selectedMemberParent.level) + 1 : 0,
                'alignment': this.selectedAlignment
            };
            this.userService.create(params).subscribe(data => {
                this.submitted = false;
                this.get();
                this.modalService.dismissAll('');
            }, error => {
                this.submitted = false;
                if (error && error['error'] && error['error']['errors'] && error['error'].hasOwnProperty('errors')) {
                    if (error['error']['errors'].username && error['error']['errors'].username.length > 0) {
                        this.alertService.showErrors('The username has already been taken');
                        return;
                    }
                    if (error['error']['errors'].email && error['error']['errors'].email.length > 0) {
                        this.alertService.showErrors(error['error']['errors'].email[0]);
                        return;
                    }
                    if (error['error']['errors'].contact && error['error']['errors'].contact.length > 0) {
                        this.alertService.showErrors(error['error']['errors'].contact[0]);
                        return;
                    }
                }
            });
        }
    }

    open(url) {
        window.open(url, '_blank');
    }
}
